// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"horizontal-scroll_scrollWrapper__W9m3Q","scroll":"horizontal-scroll_scroll__bNy0d"};